export const SEGMENT_LIMITS = {
  Individual: { min: 500, max: 30_000, step: 250, initial: 500 },
  Business: { min: 1000, max: 30_000, step: 500, initial: 1000 },
  NoNe: { min: 0, max: 0, step:0, initial: 0 }
}
